// 创建文件en/index.js
const Indonesia = {
    rejected: "Ditolak",
    my: "Saya",
    today: "Hari ini",
    this_week: "Minggu ini",
    this_month: "Bulan ini",
    last_month: "Bulan lalu",
    this_year: "Tahun ini",
    number_of_people: "Jumlah Orang",
    amount: "Jumlah Uang",
    enter_username_id_to_search: "Masukkan Nama Pengguna ID untuk Pencarian",
    team_list: "Daftar Tim",
    registration_time: "Waktu Pendaftaran",
    selling_face_value: "Nilai Jual",
    click_for_details: "Klik untuk Detail",
    "agent_login": "Masuk Agen",
    'SignOut': 'Keluar dari Akun',
    'Contact us': "Hubungi kami",
    'Download our app': "Unduh aplikasi kami",
    'Download it from': "URL unduhan",
    'About Us': "tentang Kami",
    'Gobuy USA was founded in 2012': "Gobuy AS didirikan pada tahun 2012",
    'Customer service': "pelayanan pelanggan",
    'frequently asked question': "Pertanyaan Umum",
    'Return and exchange policy': "Kebijakan pengembalian dan penukaran",
    'Shipping and distribution': "Distribusi dan pengiriman",
    'Contact us by email': "Hubungi kami melalui email",
    'Privacy Policy and Terms of Use': "Kebijakan Privasi dan Ketentuan Penggunaan",
    'Privacy Policy': "kebijakan privasi",
    'Terms of use': "ketentuan penggunaan",
    'Upload credentials': "Unggah kredensial",
    'The withdrawal is being processed': "Penarikan sedang berlangsung",
    'Cause of failure': "Alasan kegagalan",
    'Your shopping cart is still empty': "Keranjang belanja Anda masih kosong",
    'Log in to view the items in your cart': "Masuk untuk melihat item di keranjang belanja",
    'Browse around': "Jelajahi",
    'Account correlation': "Terkait akun",
    'Order management': "Manajemen pesanan",
    'Payment method': "Metode pembayaran",
    'Collection address': "Alamat pembayaran",
    Category: "Klasifikasi",
    "MyCommission": "komisi saya",
    "Gross income": "pendapatan total",
    "Direct commission": "komisi langsung",
    "Indirect commission": "komisi tidak langsung",
    "Transfer to wallet": "Transfer ke dompet",
    "Tip: The transfer amount must be greater than 10USDT": "Tip: Jumlah transfer harus lebih besar dari 10USDT",
    "transfer": "transfer",
    "commission": "komisi",
    "Please enter": "Silakan masuk",
    'Old Password': "Kata Sandi Lama",
    'Change password': "Ubah kata sandi",
    'Amazon GIFT CARD': "Kartu hadiah Amazon",
    'High Priced Recycling': "Daur ulang dengan harga tinggi",
    'Data': "tanggal",
    'congratulations': "Selamat",
    'Obtain': "mendapatkan",
    'ThankYouForParticipating': "Terima kasih telah berpartisipasi",

    // navbar"",
    Home: "halaman depan",
    Search: "mencari",
    ShoppingCart: "keranjang belanja",
    Mine: "milikku",

    // 首页
    // 搜索
    EnterSearchContent: "Masukkan konten pencarian",
    'Recent searches': "Pencarian terkini",
    'popular searches': "Pencarian populer",
    'Please search': "Silakan masukkan kata kunci yang ingin Anda cari",
    'orderSearch': "Masukkan pesanan atau nama produk yang akan dicari",

    // 语言
    'Language selection': "Pemilihan bahasa",

    // menu
    Brand: "merek",
    Collect: "mengumpulkan",
    Manage: "mengelola",
    Order: "Memesan",
    Wallet: "dompet",
    BlindBox: "kotak buta",
    MenuGiftCard: "kartu hadiah",
    // HotSale
    HotSale: "Berita terbaru sedang dijual...",
    // tabs"",
    TodaysOffer: "Pilihan Platform",
    'Phone': "ponsel",
    'Smart Watch': "jam tangan pintar",
    'Smart bracelet': "gelang pintar",

    // gobuy
    'home.gobuy.title': "Kejutan menanti Anda",
    'home.gobuy.periods': "kotak buta bulat",
    'home.gobuy.freeze': "Berpartisipasi dalam hitungan mundur",
    'home.gobuy.drawing': "Mulai hitung mundur",
    'home.gobuy.buy': "ikut",
    'home.gobuy.isbuy': "Sudah berpartisipasi",
    USDT: "USDT",
    'home.gobuy.jackpot': "Kumpulan hadiah",
    Purse: "dompet",
    Box: "kotak buta",
    'GetAPrize': "Dapatkan hadiah",
    Discount: "Diskon",
    when: "Kapan",
    points: "integral",
    seconds: "Kedua",
    // MessageBox
    'MessageBox.Tips': "petunjuk",
    'MessageBox.Confirm': "mengonfirmasi",
    'MessageBox.Cancel': "Membatalkan",
    'MessageBox.buy.box': "Apakah Anda yakin ingin membeli kotak buta ini?",
    // Toast
    'succ': "kesuksesan",
    'err': "kesalahan",
    'box.succeeds': "Pembelian berhasil",
    'box.frozen': "Sudah berpartisipasi",
    'box.issue': "Hanya satu kotak buta yang dapat dibeli per terbitan",

    // 商品列表
    filter: "menyaring",
    sales: "Volume penjualan",
    selfOP: "Dioperasikan sendiri",
    noMore: "tidak lebih",
    brand: "merek",
    confirm: "mengonfirmasi",
    reset: "mengatur ulang",
    ComSor: "Penyortiran yang komprehensif",
    MostPop: "paling populer",
    HighLow: "Harga dari tinggi ke rendah",
    LowHigh: "Harga dari rendah ke tinggi",
    SalVol: "volume penjualan",
    NewArr: "Kedatangan baru",

    // 购物车
    'cart.cart': "keranjang belanja",
    'cart.edit': "sunting",
    'cart.done': "Menyelesaikan",
    'home.cart.voucher': "Dapatkan kupon",
    'home.cart.outstock': "stok Habis",
    'home.cart.offshelf': "Dihapus dari rak",
    'Only': "hanya",
    'left': "individu",
    'Promotion': "Promosi",
    'cart.all': "Pilih semua",
    'cart.total': "total",
    'cart.delete': "menghapus",
    'cart.checkout': "Tolong, Bill",

    // 我的
    'Direct': "langsung",
    'Indirect': "tidak langsung",
    'MyOrders': "pesanan saya",
    'ViewAll': "Lihat semuanya",
    'Unpaid': "Pembayaran tertunda",
    'ToShip': "Menunggu pengiriman",
    'ToReceive': "Menunggu tanda terima",
    'ToReview': "Menunggu evaluasi",
    // 盲盒
    'MyBlindBox': "Daftar kotak buta",
    'WaitingDraw': "Menunggu pengundian",
    'Opened': "Dibuka (menerima/mengembalikan)",
    // 礼品卡
    'After sale': "Purna jual",
    'GiftCard': "Catatan daur ulang",
    'RecycleGiftCard': "Daur ulang kartu hadiah",
    'Verifying': "memeriksa",
    'Rebuying': "Pembelian kembali",
    'Repurchased': "Menunggu pembayaran",
    'Paid': "Pembayaran telah dilakukan",
    // 常用工具
    'CommonTools': "Alat umum",
    'MyWallet': "dompet saya",
    'VirtualOrders': "pesanan maya",
    'Refunds': "Pengembalian dana",
    'MyFriends': "teman-teman saya",
    'ChatList': "daftar obrolan",
    'RealNameVerification': "Otentikasi nama asli",
    'MyFavorites': "koleksi saya",
    'Addresses': "Manajemen alamat",
    'MyReviews': "Ulasan saya",
    'BrowsingHistory': "Jelajahi riwayat",
    'Promotions': "promosi",
    'StoreManagement': "manajemen toko",
    'BecomeASeller': "Menjadi penjual",

    // 订单列表
    'SearchPlaceholder': "Masukkan nama produk pesanan yang akan dicari",
    All: "semua",
    OrderNo: "Nomor pesanan",
    items: "bagian-bagian",
    ShippingFee: "kargo",
    'Refund in Progress': "Pengembalian dana sedang berlangsung",
    'Cancel Order': "Batalkan pesanan",
    'Refund': "Pengembalian dana",
    'Track Shipping': "memeriksa logistik",
    'Confirm Receipt': "konfirmasi penerimaan barang",
    'Evaluate': "mengevaluasi",
    'Delete': "menghapus",
    'Pay': "Pembayaran",
    'MessageBox.delete.order': "Apakah Anda yakin ingin menghapus pesanan ini?",
    'MessageBox.cancel.order': "Apakah Anda yakin ingin membatalkan pesanan ini?",
    'MessageBox.receive.order': "Apakah pesanan ini sudah diterima?",
    // 订单详情
    'Order Details': "Detail pesanan",
    'Pickup Code': "Kode pengambilan",
    'Complaint': "keluhan",
    'After-Sales': "Purna jual",
    'Gift': "Hadiah",
    'Order Date': "tanggal pemesanan",
    'Used voucher worth': "Jumlah voucher yang digunakan",
    'CNY': "RMB",
    'Payment Method': "Metode pembayaran",
    'Total Product Amount': "Jumlah total produk",
    'Shipping Fee': "kargo",
    'Amount Paid': "Jumlah yang dibayarkan",
    'Return': "mengembalikan barang",
    // 盲盒列表
    'Pending Draw': "Menunggu undian lotere",
    'Pending Unboxing': "Untuk dibuka",
    'Unboxed': "Sudah dihidupkan",
    'Collected': "Diterima",
    'Recycled': "Daur ulang",
    'Unknown': "tidak dikenal",
    'Claim': "menerima",
    'Recycle': "Pembelian kembali",
    'Unbox': "menyalakan",
    'MessageBox.recycle.box': "Apakah Anda yakin ingin mendaur ulang kotak buta ini?",
    // 盲盒详情
    'Mystery Box Details': "Detail kotak buta",
    'Unopened': "Tidak dihidupkan",
    'box.opened': "Tidak dihidupkan",
    'Claimed': "Diterima",
    'Confirm Claim': "Konfirmasikan pengumpulan",
    'MessageBox.pick.box': "Apakah Anda yakin ingin mengekstrak kotak buta ini?",
    // 盲盒提货
    'Please add address': "Silakan tambahkan alamat",
    // 礼品卡列表
    'Face Value Total': "Nilai nominal keseluruhan",
    // 礼品卡详情
    'Gift Card Details': "Detail kartu hadiah",
    'Card number': "nomor kartu",
    'Activation code': "kode aktivasi",
    'Actual recovery price': "harga daur ulang sebenarnya",
    // 礼品卡回收
    'Gift Card Recycling': "Daur ulang kartu hadiah",
    'Confirm Recycling': "Konfirmasikan daur ulang",
    'Please enter the card number': "Silakan masukkan nomor kartu",
    'Please enter the activation code': "Silakan masukkan kode aktivasi",
    'MessageBox.recycle.gift': "Yakin ingin mendaur ulang kartu hadiah ini?",

    // 我的钱包
    'My Wallet': "dompet saya",
    'Available Balance': "saldo yang tersedia",
    'Frozen Funds': "membekukan dana",
    'Recharge': "isi ulang",
    "can": "Dapat",
    'Withdraw': "Tarik uang tunai",
    'Withdrawal Accounts': "Tarik akun",
    // 充值
    'Recharge Details': "Detail isi ulang",
    'Recharge Order No.': "Nomor pesanan isi ulang",
    'Recharge Amount': "Jumlah isi ulang",
    'Creation Time': "waktu penciptaan",
    'MessageBox.recharge.pop': "Silakan masukkan jumlah isi ulang",
    // 付款
    'payment': "Pembayaran",
    'Order submitted successfully, please select payment method': "Pesanan berhasil dikirimkan, silakan pilih metode pembayaran",
    'Rechargeable card': "kartu yang dapat diisi ulang",
    'Please enter a hash': "Silakan masukkan hashnya",
    'Immediate payment': "Bayar sekarang",
    'Wait for the file to load': "Harap tunggu hingga file dimuat",
    // 提现
    'Withdrawal Details': "Detail penarikan",
    'Withdrawal Amount': "Jumlah penarikan",
    'Application Time': "Waktu aplikasi",
    'New Application': "aplikasi baru",
    'Payment Password': "Kata sandi pembayaran",
    'New Payment Password': "Kata sandi pembayaran baru",
    'Recipient Information': "Informasi penerima pembayaran",
    'Submit': "kirim",
    'Add Recipient Account First': "Silakan tambahkan akun pembayaran terlebih dahulu",
    'Please bind your mobile phone or email first': "Silakan ikat ponsel atau email Anda terlebih dahulu",
    // 设置
    'Account Settings': "Pengaturan akun",
    'Change Login Password': "Ubah kata sandi masuk",
    'Change Payment Password': "Ubah kata sandi pembayaran",
    'Log Out': "Keluar",
    'Mobile': "ponsel",
    'Verification Code': "Kode verifikasi",
    'Email': "Surat",
    'New Password': "Kata Sandi Baru",
    'Confirm Password': "Konfirmasi Kata Sandi",
    'Modify': "Merevisi",
    'Bind': "mengikat",
    ' Mobile': "ponsel",
    ' Email': "Surat",
    // 资金详情
    'Fund Details': "Detail pendanaan",
    'Withdrawal Account': "Tarik akun",
    'Account Type': "Jenis akun",
    'USDT Address (TRC20)': "Alamat USDT (TRC20)",
    'Edit': "sunting",
    'Delete': "menghapus",
    'Add New': "Tambahkan akun baru",
    'MessageBox.delete.bank': "Apakah Anda yakin ingin menghapus akun penarikan ini?",
    // 登录
    'Login': "Masuk",
    'Sign Up': "daftar",
    'Normal Login': "Masuk biasa",
    'Username / Email / Phone Number': "Nama pengguna/email",
    'Enter Phone Number': "Silakan masukkan nomor ponsel",
    'Enter Email': "Silakan masukkan email",
    'Enter SMS Code': "Silakan masukkan kode verifikasi SMS",
    'Enter Password': "Silakan masukkan kata sandi",
    "enter_login_password_for_verification": "Silakan masukkan kata sandi masuk Anda untuk verifikasi",
    'Forgot Password': "lupa kata sandinya",
    'Third-party Login': "Masuk pihak ketiga",
    'Please complete the form': "Silakan lengkapi formulirnya",
    'WeChat': "Wechat wechat",
    'Weibo': "weibo",
    'QQ': "QQ",
    'phone login': "Login seluler",
    'Login Expired': "Masa masuk telah habis",
    'Please enter your phone number first': "Silakan masukkan nomor ponsel Anda terlebih dahulu",
    'Please enter your username/email/phone number': "Silakan masukkan nama pengguna/email",
    'Please enter your password': "Silakan masukkan kata sandi",
    'Password must be at least 6 characters': "Kata sandi minimal harus 6 karakter",
    'Please enter an 11-digit phone number': "Silakan masukkan 11 digit nomor ponsel Anda",
    'Please wait for the file to finish loading': "Harap tunggu hingga file dimuat",
    'send': "mengirim",
    'signUpTips': "Data pribadi Anda akan digunakan untuk mendukung pengalaman Anda di seluruh situs web, mengelola akses ke akun Anda, dan untuk tujuan lain yang dijelaskan dalam Kebijakan Privasi kami.",

    // 注册
    'Sign Up': "daftar",
    'Referrer': "pemberi rekomendasi",
    'Invitation code': "Kode undangan",
    'Invite friends': "Undang teman",
    'Username': "nama belakang",
    'Full Name': "nama asli",
    'Set Password': "Tetapkan kata sandi",
    'Confirm Password': "Konfirmasi Kata Sandi",
    'Phone Number': "nomor telepon",
    'Email': "e-mail",
    'Username: 3-25 chars, letters & numbers': "Nama pengguna: 3-25 karakter, huruf dan angka",
    '6-20 digits/letters/symbols': "6-20 digit/huruf/simbol",
    'By clicking sign up, you agree to': "Dengan mengklik untuk mendaftar, Anda setuju",
    'User Agreement': "Perjanjian Pengguna",
    'Please check the user agreement': "Silakan periksa perjanjian pengguna",
    'Please enter a username with 3-25 characters': "Silakan masukkan nama pengguna 3-25 karakter",
    'Enter SMS Verification Code': "Silakan masukkan kode verifikasi SMS",
    'Please enter your phone number': "Silakan masukkan nomor ponsel Anda",
    'Please enter the verification code': "Silakan masukkan kode verifikasi",
    'Please enter a 6-digit verification code': "Silakan masukkan kode verifikasi 6 digit",
    'Please enter a password with 6-20 characters': "Silakan masukkan kata sandi 6-20 karakter",
    'Please enter the confirm password': "Silakan masukkan kata sandi konfirmasi",
    'The confirm password does not match the entered password': "Kata sandi konfirmasi tidak sesuai dengan kata sandi yang dimasukkan",

    // 密码恢复
    'Password Recovery': "Pemulihan kata sandi",
    'Forgot Password': "lupa kata sandinya",
    'Forget.email.tips': "Jika akun Anda belum dikaitkan dengan nomor email, silakan hubungi Administrator Platform untuk memulihkan kata sandi Anda.",

    // 通知
    'Notification Message': "pesan pemberitahuan",
    'Direct Message': "pesan pribadi",
    'System Message': "Pesan sistem",
    'Leave a Message': "pesan",

    // 配送地址
    'Delivery Address': "alamat pengiriman",
    'The store is no longer valid, please edit the delivery address again': "Toko ini sudah tidak valid, harap edit ulang alamat pengiriman",
    'Default address': "Alamat bawaan",
    'Add address': "Tambahkan alamat",
    'Edit address': "Sunting alamat",
    'MessageBox.delete.address': "Apakah Anda yakin ingin menghapus alamat ini?",
    'name': "Nama",
    'phone': "Nomor telepon",
    'district': "daerah",
    'address': "alamat",
    'default address': "Alamat bawaan",
    'save and use': "Simpan dan gunakan",
    'save': "menyimpan",
    'Please select a region': "Silakan pilih wilayah",
    'Please fill in the recipient name': "Silakan masukkan nama penerima",
    'Name must be 2-15 characters': "Nama harus terdiri dari 2-15 karakter",
    'Please fill in the mobile phone number': "Silakan masukkan nomor ponsel",
    'Please select your location': "Silakan pilih lokasi Anda",
    'Please fill in the detailed address': "Silakan isi alamat detailnya",

    // 浏览历史
    'Browsing History': "Jelajahi riwayat",
    'Clear browsing history': "Hapus riwayat penelusuran",

    // 推广会员
    'Promotion member': "Promosikan anggota",
    "“PromotionPoster”": "poster promosi",
    "MemberName": "Nama anggota",
    "MyAssets": "aset saya",
    "DistributedAmount": "Jumlah distribusi",
    "NumberOfDistributedProducts": "Tetapkan kuantitas produk",
    "DistributedProductAmount": "Jumlah distribusi",
    "MyTeam": "tim saya",
    "LevelOneMembers": "anggota kelas satu",
    "LevelTwoMembers": "anggota tingkat kedua",
    "PromotionPoster": "poster promosi",
    "PromotionMembers": "Promosikan anggota",
    "PromotionPerformance": "kinerja promosi",
    "ViewPromotionLink": "Klik untuk melihat tautan promosi",
    "PromoteViaWeChatQRCode": "Promosikan melalui kode QR WeChat",
    "Copy": "menyalin",
    "BrowserNotSupportedCopyManually": "Browser Anda tidak mendukung penyalinan langsung, harap salin secara manual",
    "GiftCardRecoveryTotal": "Jumlah total kartu hadiah yang didaur ulang",
    "TodaysGiftCardRecoveryCount": "Jumlah daur ulang kartu hadiah hari ini",
    "RegistrationDate": "Tanggal pendaftaran",
    "LastLogin": "login terakhir",
    "Promotion Commission": "Komisi promosi",

    // userinfo 个人信息
    "Personal Info": "informasi pribadi",
    "Nickname": "nama panggilan",
    "Birthdate": "tanggal lahir",
    "Save": "menyimpan",
    "CropImage": "Pangkas gambar",
    "UseImage": "Gunakan gambar",

    // goodsDetail 商品详情
    "Off": "Diskon",
    "Sold": "terjual",
    "Product": "produk",
    "Comment": "Komentar",
    "Details": "Detail",
    "ReportViolation": "laporan",
    "Cart": "keranjang belanja",
    "ChatMessages": "Pesan obrolan",
    "MyShop": "toko saya",
    "MerchantLogin": "Login pedagang",
    "Share": "membagikan",
    "ShareTo": "Bagikan ke",
    "WeChat": "Wechat wechat",
    "Copy": "menyalin",
    "Poster": "poster",
    "BrowserNotSupportedCopyManually": "Browser Anda tidak mendukung penyalinan langsung, harap salin secara manual",
    "Follow": "fokus pada",
    "Unfollow": "Berhenti mengikuti",
    "PleaseSelectQuantityAndCategory": "Silakan pilih jumlah dan kategori.",
    "SelectedWithQuantity1": "{spesifikasi} yang dipilih, kuantitas {angka}.",
    "SelectedQuantity1": "Kuantitas yang dipilih {number}.",
    "SelectedWithQuantity2": "{spesifikasi} yang dipilih, kuantitas {angka}.",
    "Add to cart": "tambahkan ke troli",
    "Buy now": "Beli sekarang",
    "Stock": "dalam stok",
    "Pieces": "bagian-bagian",
    "Quantity": "kuantitas",
    "All": "semua",
    "Good": "Ulasan bagus",
    "Medium": "Peringkat netral",
    "Bad": "Ulasan buruk",
    // 评论
    "Product review": "ulasan produk",
    "anonymous": "anonim",
    "noReviewInfo": "Tidak ada informasi komentar yang disediakan",
    "Shop Owners Response": "Penjaga toko merespons",
    "This product has no current reviews": "Saat ini belum ada ulasan untuk produk ini",
    "Product details": "Detail produk",
    "shop": "toko",
    "customerService": "pelayanan pelanggan",
    "shoppingCart": "keranjang belanja",
    "addToCart": "tambahkan ke troli",
    "buyNow": "Beli sekarang",
    "outOfStock": "Produk yang dipilih saat ini sedang habis, maaf!",
    "notAvailable": "Produk yang dipilih sudah tidak tersedia, maaf!",
    "Store order message": "Berita pesanan toko",
    "Confirm the order": "Konfirmasikan pesanan",
    "productAmount": "Jumlah produk",
    "discount": "Diskon",
    "shippingFee": "kargo",
    "subtotal": "Simpan subtotalnya",
    "Submit an order": "Kirim pesanan",
    // 退货
    "refundAdd": "Tambahkan pengembalian dana",
    "back": "kembali",
    "refundDescription": "Instruksi pengembalian dana:",
    "proofOfRefund": "Voucher pengembalian dana",
    "use": "menggunakan",
}
export default Indonesia
